<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Захтеви - општи подаци') }}
    </h1>
  </div>

  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span *ngIf="state === viewState.Edit">
          <i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за измену захтева, молимо попуните потребне податке, сачувати промене притиском на дугме "Сачувај"') }}</span>
        <span *ngIf="state === viewState.Create">
          <i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за додавање новог захтева, молимо попуните потребне податке, сачувати промене притиском на дугме "Сачувај"') }}</span>
        <span *ngIf="state === viewState.Details">
          <i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за детаљни приказ захтева') }}</span>
      </div>
    </div>

    <div class="form-blocks">
      <div>
        <div class="content">
          <div class="form-element">
            <input type="hidden" name="id" [(ngModel)]="form.elements['id'].value">
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Број захтева') }}</label>
              <div class="static">
                <span>{{ form.elements['id'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element"
              [ngClass]="{ 'error': form.elements['requestName'].error.required || form.elements['requestName'].error.invalid }">
              <label>{{ translationManager.getTranslation('Назив захтева') }}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <input type="text" [(ngModel)]="form.elements['requestName'].value" maxlength="300">
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static">
                  <span>{{ form.elements['requestName'].value | appvalue }}</span>
                </div>
              </div>
              <div class="errors">
                <span *ngIf="form.elements['requestName'].error.required">
                  <i
                    class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element"
              [ngClass]="{ 'error': form.elements['budgetStatusId'].error.required || form.elements['budgetStatusId'].error.invalid }">
              <label>{{ translationManager.getTranslation('Буџетски статус') }}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <select [(ngModel)]="form.elements['budgetStatusId'].value"
                  (change)="changeBudgetStatus($event.target.value)">
                  <option></option>
                  <option *ngFor="let item of budgetStatuses" [value]="item.id">
                    {{ translationManager.getTranslation('BudgetStatus-Name#' + item.id) }}
                  </option>
                </select>
              </div>
              <div class="errors">
                <span *ngIf="form.elements['budgetStatusId'].error.required">
                  <i
                    class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static">
                  <span>{{ translationManager.getTranslation('BudgetStatus-Name#' + form.elements['budgetStatusId'].value) | appvalue }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element"
              [ngClass]="{ 'error': form.elements['procurementCategoryId'].error.required || form.elements['procurementCategoryId'].error.invalid }">
              <label>{{ translationManager.getTranslation('Категорија набавке') }}</label>

              <div class="content"
                [ngClass]="{ 'with-action': state === viewState.Create || state === viewState.Edit }">
                <div class="static">
                  <span>{{ form.elements['procurementCategoryName'].value | appvalue }}</span>
                </div>
                <div class="action" *ngIf="state === viewState.Create || state === viewState.Edit">
                  <a href="javascript:;" [title]=" translationManager.getTranslation('Селектуј категорију набавке')"
                    (click)="selectProcurementCategory()">
                    <i class="fa fa-search mr-2"></i>
                  </a>
                </div>
              </div>
              <div class="errors">
                <span *ngIf="form.elements['procurementCategoryId'].error.required">
                  <i
                    class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element"
              [ngClass]="{ 'error': form.elements['procurementModelId'].error.required || form.elements['procurementModelId'].error.invalid }">
              <label>{{ translationManager.getTranslation('Модел набавке') }}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <select [(ngModel)]="form.elements['procurementModelId'].value"
                  (change)="changeProcurementModel($event.target.value)">
                  <option></option>
                  <option *ngFor="let item of procurementModels" [value]="item.id">
                    {{ translationManager.getTranslation('ProcurementModel-Name#' + item.id) }}
                  </option>
                </select>
              </div>
              <div class="errors">
                <span *ngIf="form.elements['procurementModelId'].error.required">
                  <i
                    class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static">
                  <span>{{ translationManager.getTranslation('ProcurementModel-Name#' + form.elements['procurementModelId'].value) | appvalue }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Статус захтева') }}</label>
              <div class="static">
                <span>{{ form.elements['requestStatus'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Референт набавке') }}</label>
              <div class="static">
                <span>{{ form.elements['requestAssignedUser'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Референт набавке ЕРПИД') }}</label>
              <div class="static">
                <span>{{ form.elements['requestAssignedUserErpId'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element"
              [ngClass]="{ 'error': form.elements['requestSubject'].error.required || form.elements['requestSubject'].error.invalid }">
              <label>{{ translationManager.getTranslation('Предмет захтева') }}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <textarea class="form-control" [(ngModel)]="form.elements['requestSubject'].value"></textarea>
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static">
                  <span>{{ form.elements['requestSubject'].value | appvalue }}</span>
                </div>
              </div>
              <div class="errors">
                <span *ngIf="form.elements['requestSubject'].error.required">
                  <i
                    class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" [ngClass]="{ 'error': form.elements['plannedRoundsNumber'].error.invalid }">
              <label>{{ translationManager.getTranslation('Планирани број рунди') }}</label>
              <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
                <input type="text" [(ngModel)]="form.elements['plannedRoundsNumber'].value" maxlength="300">
              </div>
              <div class="content" *ngIf="state === viewState.Details">
                <div class="static">
                  <span>{{ form.elements['plannedRoundsNumber'].value | appvalue }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Креирао') }}</label>
              <div class="static">
                <span>{{ form.elements['createdByName'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Датум креирања') }}</label>
              <div class="static">
                <span>{{ form.elements['createdOn'].value | appdate | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Изменио') }}</label>
              <div class="static">
                <span>{{ form.elements['updatedByName'].value | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" *ngIf="state === viewState.Details">
              <label>{{ translationManager.getTranslation('Датум последње измене') }}</label>
              <div class="static">
                <span>{{ form.elements['updatedOn'].value | appdate | appvalue }}</span>
              </div>
            </div>
          </div>

          <div class="app-table" *ngIf="requestAssignedUserHistoryList && requestAssignedUserHistoryList.length != 0">
            <table class="table table-striped text-dark-m1">
              <thead>
                <tr class="bgc-primary-tp2 text-white">
                  <th>
                    {{ translationManager.getTranslation('Референт набавке') }}
                  </th>
                  <th>
                    {{ translationManager.getTranslation('Изменио') }}
                  </th>
                  <th>
                    {{ translationManager.getTranslation('Датум измене') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of requestAssignedUserHistoryList">
                  <td>{{item.assignedUser}}</td>
                  <td>{{item.createdBy}}</td>
                  <td>{{item.createdOn | appdate | appvalue }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-element-buttons">
            <button class="btn btn-warning fl" (click)="navigateToList()">
              <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
            <button class="btn btn-success fr" (click)="submit()"
              *ngIf="state === viewState.Create || state === viewState.Edit">
              <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<procurement-category-select #procurementCategorySelect></procurement-category-select>
